var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatausageOld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.431,
    height: 17.484,
    viewBox: "0 0 22.431 17.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -56.459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.318,181.126l1.1-1.1a2.068,2.068,0,0,0,2.767-2.767l4.091-4.091a.657.657,0,0,0-.929-.929l-4.091,4.091a2.068,2.068,0,0,0-2.767,2.767l-1.1,1.1a.657.657,0,1,0,.929.929Zm2.024-3.7a.751.751,0,1,1-.751.751A.751.751,0,0,1,187.342,177.422Z",
    transform: "translate(-176.127 -110.518)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.258,101.465l4.811,2.777a5.727,5.727,0,0,1,1.166-1.166l-2.777-4.811A11.306,11.306,0,0,0,42.258,101.465Z",
    transform: "translate(-40.407 -39.975)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,62.015V56.459a11.134,11.134,0,0,0-4.371,1.172l2.777,4.811A5.633,5.633,0,0,1,145.6,62.015Z",
    transform: "translate(-135.044 0)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.984,200.017,1.172,197.24A11.134,11.134,0,0,0,0,201.611H5.556A5.631,5.631,0,0,1,5.984,200.017Z",
    transform: "translate(0 -134.613)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.851,201.611h5.556a11.134,11.134,0,0,0-1.172-4.371l-4.811,2.777A5.632,5.632,0,0,1,375.851,201.611Z",
    transform: "translate(-358.976 -134.613)",
    fill: "#8895aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.557,327.008H0a11.2,11.2,0,0,0,1.483,4.951.657.657,0,0,0,.9.24l3.657-2.113a.657.657,0,0,0,.24-.9,5.664,5.664,0,0,1-.721-2.181Z",
    transform: "translate(0 -258.696)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.771,329.188a.657.657,0,0,0,.24.9l3.657,2.113a.657.657,0,0,0,.9-.24,11.2,11.2,0,0,0,1.483-4.951h-5.557A5.664,5.664,0,0,1,366.771,329.188Z",
    transform: "translate(-350.618 -258.695)",
    fill: "#8895aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.371,57.631A11.134,11.134,0,0,0,271,56.459v5.556a5.631,5.631,0,0,1,1.593.427Z",
    transform: "translate(-259.127)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.756,425.541h-4.223a.657.657,0,0,0,0,1.314h4.223A.657.657,0,0,0,197.756,425.541Z",
    transform: "translate(-184.429 -352.912)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.619,100.761a1.971,1.971,0,0,1,.525,1.841l1.97-1.137a11.306,11.306,0,0,0-3.2-3.2l-1.137,1.969A1.966,1.966,0,0,1,372.619,100.761Z",
    transform: "translate(-354.535 -39.975)",
    fill: "#697384"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatausageOld);
export default __webpack_public_path__ + "static/media/datausage-old.0ed3cb9a321257db4e648a78a6b176c8.svg";
export { ForwardRef as ReactComponent };